import { render, staticRenderFns } from "./PasswordResetEmail.vue?vue&type=template&id=51164d00&"
import script from "./PasswordResetEmail.vue?vue&type=script&lang=js&"
export * from "./PasswordResetEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports